const object = (value) => {
  try {
    const parsed = typeof value === "string" ? JSON.parse(value) : value;
    if (Array.isArray(parsed)) return parsed.find((item) => item && typeof item === "object") || {};
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch { return {}; }
};

// Billing currency belongs to the server cart, independently of the browsed address.
export const getCartCurrency = (source) => {
  const data = object(source);
  const receipt = object(data.receipt);
  for (const value of [receipt.currency, receipt.currency_code, receipt.currencyCode, data.currency, data.currency_code, data.currencyCode]) {
    if (typeof value === "string" && value.trim() && !["null", "undefined"].includes(value.trim().toLowerCase())) {
      return value.trim().toUpperCase();
    }
  }
  return "";
};
